import React from "react";
import CardHeader from "../common/CardHeader";
import SignatureCanvas from "react-signature-canvas";

export default function SignaturePad({
  dependentOn,
  error,
  onEnd,
  reference,
  label,
  subTitle,
  clearFn,
}) {
  return (
    <div className="mb-2">
      <div className="shadow-md rounded-lg bg-white">
        <div className="p-4">
          <CardHeader
            settings={{ headingText: label, description: subTitle }}
          />

          <div className="px-4 pt-4">
            <div className={`grid md:grid-cols-2 ${error ? "border border-red-500" : ""}`}>
              <div>
                <p className="text-sm italic">
                  When signing this form, use your mouse or touchpad pen to sign
                  in the box below (with the best version of your signature)
                </p>
                <div className="mt-2 h-56">
                  <SignatureCanvas
                    ref={reference}
                    canvasProps={{
                      className: "w-[100%] h-[100%] border border-gray-200 rounded-lg",
                      willReadFrequently: true,
                    }}
                    onEnd={onEnd}
                  />
                </div>
              </div>
              <div className="flex md:justify-start justify-end items-end ml-4 mt-4">
                <button className="flex items-center px-6 py-3.5 font-medium text-white bg-blue-600 cursor-pointer shadow hover:bg-blue-500 rounded-full" onClick={clearFn} type="button">Clear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
